import { mapGetters, mapActions } from 'vuex';
import format from '@/common/utilities/format';
import sort from '@/common/utilities/sort';
import estprice from '@/common/utilities/estprice';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';
import mapper from '@/common/store/mapper/index.js';

import propertyEstimateItem from '@/dpp/components/propertyestimate/property-estimateitem.vue';
import mvtEstPriceItem from '@/common/components/mvtestprice/mvt-estpriceitem.vue';
import mvtEstPriceChart from '@/common/components/mvtestprice/mvt-estpricechart.vue';

function getPropertyList(arr, glb) {
    if (arr && arr.length) {
        return arr.map((e) => {
            return mapper.property(e, glb);
        });
    }
    return [];
}
export default {
    name: 'mvtEstPrice',
    inject: ['$eventBus'],
    components: {
        propertyEstimateItem,
        mvtDropdownList,
        mvtEstPriceItem,
        mvtEstPriceChart,
    },
    props: {
        dpp: {
            type: Object,
            default: () => {
                return {};
            },
        },
        showPriceEst: {
            type: Boolean,
            default: true,
        },
        showAVM: {
            type: Boolean,
            default: true,
        },
        isMarket5YLoaded: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('glb', ['glb', 'viewedListings', 'getRecentlyViewed', 'favoriteListings']),
        isMymovotoUI() {
            //wish we could remove inconsistent code's
            return this.glb.pageType === 'vmymovoto_ownedhomes';
        },
        getNearbyHome() {
            return this.dpp.nearbyHomes;
        },
        getNearbySoldHomes() {
            return this.dpp.nearbySoldHomes;
        },
        getForecast() {
            return this.dpp.forecast;
        },
        getMarket5Y() {
            return this.dpp.market5Y;
        },
        getAvmText() {
            if (this.dpp.avmInfo) {
                return `$${format.friendlyPrice(this.dpp.avmInfo.valuation)}`;
            }
            return '';
        },
        getAvmRangText() {
            if (this.dpp.avmInfo) {
                return `$${format.friendlyPrice(this.dpp.avmInfo.minValuation)} - $${format.friendlyPrice(this.dpp.avmInfo.maxValuation)}`;
            }
            return '';
        },
        getAvmPrice() {
            if (this.dpp.avmInfo) {
                return `$${format.formatNumberByComma(this.dpp.avmInfo.valuation)}`;
            }
            return '';
        },
        openAvmDisclaimer3() {
            this.$eventBus.$emit('property-pop-avm-disclaimer3');
        },
        openAvmDisclaimer4() {
            this.$eventBus.$emit('property-pop-avm-disclaimer4');
        },
        hasMore() {
            return this.comparableHomeSource.length > this.comparableCount;
        },
        priceChanged() {
            if (this.getForecast && this.getForecast.lastMonthPrice && this.estPrice) {
                return this.estPrice - this.getForecast.lastMonthPrice;
            }
            return 0;
        },
        forecastPriceChange() {
            if (this.getForecast && this.getForecast.price) {
                return this.getForecast.price - this.estPrice;
            }
            return 0;
        },
        forecastPriceRate() {
            if (this.getForecast && this.getForecast.rate) {
                return this.getForecast.rate;
            }
            return 0;
        },
        forecastPriceIncrease() {
            return this.forecastPriceRate > 0;
        },
        isIncrease() {
            return this.priceChanged > 0;
        },
        comparableSourceType() {
            if (this.comparableType === 'sale') {
                return this.isCompareLandWithHomes ? 'sale_land' : 'sale';
            } else if (this.comparableType === 'sold') {
                return this.isCompareLandWithHomes ? 'sold_land' : 'sold';
            } else if (this.comparableType === 'viewed') {
                return this.isCompareLandWithHomes ? 'viewed_land' : 'viewed';
            } else {
                return '';
            }
        },
        comparableHomeSource() {
            if (this.comparableSourceType === 'sale') {
                if (this.comparableSale && this.comparableSale.length) {
                    return this.comparableSale;
                } else {
                    return [];
                }
            } else if (this.comparableSourceType === 'sold') {
                if (this.comparableSold && this.comparableSold.length) {
                    return this.comparableSold;
                } else {
                    return [];
                }
            } else if (this.comparableSourceType === 'viewed') {
                if (this.comparableViewed && this.comparableViewed.length) {
                    return this.comparableViewed;
                } else {
                    return [];
                }
            }
            if (this.comparableSourceType === 'sale_land') {
                if (this.comparableSaleForLand && this.comparableSaleForLand.length) {
                    return this.comparableSaleForLand;
                } else {
                    return [];
                }
            } else if (this.comparableSourceType === 'sold_land') {
                if (this.comparableSoldForLand && this.comparableSoldForLand.length) {
                    return this.comparableSoldForLand;
                } else {
                    return [];
                }
            } else if (this.comparableSourceType === 'viewed_land') {
                if (this.comparableViewedLand && this.comparableViewedLand.length) {
                    return this.comparableViewedLand;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        },
        compareWithLand() {
            return this.dpp.isLand && !this.isCompareLandWithHomes;
        },
        isFavorite() {
            return this.favoriteListings.indexOf(this.dpp.propertyId) !== -1;
        },
        isListPriceHigher() {
            return this.dpp.listingByMovoto ? this.dpp.price < this.dpp.estPrice : true;
        },
    },
    data() {
        return {
            isOpen: false,
            loadNearbySoldForLand: false,
            loadNearBySaleForLand: false,
            loadNearbySold: false,
            loadRecentView: false,
            estPrice: null,
            estAreaPrice: null,
            area: null,
            rangeText: '',
            percentage: null,
            isAbove: false,
            usingBuildingArea: null,
            isCompareLandWithHomes: false,
            comparableCount: 4,
            comparableType: '',
            comparableSaleForLand: [],
            comparableSoldForLand: [],
            comparableViewForLand: [],
            comparableSale: [],
            comparableSold: [],
            comparableViewed: [],
            comparableViewedLand: [],
            sourceTypes: [
                {
                    text: this.molang('dpp.propertyEstimate.sale'),
                    value: 'sale',
                },
                {
                    text: this.molang('dpp.propertyEstimate.sold'),
                    value: 'sold',
                },
                {
                    text: this.molang('dpp.propertyEstimate.viewed'),
                    value: 'viewed',
                },
            ],
        };
    },
    methods: {
        ...mapActions('glb', ['fetchRecentView']),
        updateEstValue(data) {
            this.dpp.estPrice = data.estPrice;
            this.dpp.estPricePerArea = data.estPricePerArea;
            this.dpp.estPriceRange = data.estPriceRange;
        },
        ...mapActions('dpp', ['fetchNearbySold', 'fetchNearbySoldForLand', 'fetchNearbySaleForLand']),
        ...mapGetters('glb', ['getComplianceMethod']),
        updateNearbySaleForLand(data) {
            if (data) {
                let propertyList = null;
                if (Array.isArray(data) && data.length) {
                    propertyList = data;
                } else if (data.listings && data.listings.length) {
                    propertyList = data.listings;
                }
                this.dpp.nearbySaleForLand = getPropertyList(propertyList, this.glb);
            }
        },
        updateNearbySold(data) {
            if (data && data.length) {
                this.dpp.nearbySoldHomes = getPropertyList(data, this.glb);
            }
        },
        showNotSupportedByMLS() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showNotSuportByMLS') >= 0;
        },
        updateData(nearbyHome) {
            var data = estprice.getEstPriceForProperty(this.dpp, nearbyHome);
            this.estAreaPrice = data.areaPriceAvg;
            this.estPrice = data.estPrice;
            this.rangeText = data.estPriceRange;
            this.area = data.area;
            this.percentage = data.percentage;
            this.isAbove = data.isAbove;
            this.usingBuildingArea = !this.dpp.isLand && this.dpp.buildingArea && !this.dpp.sqftTotal;
            this.updateEstValue({
                estPrice: this.estPrice,
                estPricePerArea: this.estAreaPrice,
                estPriceRange: this.rangeText,
            });
        },
        estPriceByHome(flag) {
            this.isCompareLandWithHomes = flag;
        },
        updateLandDataByHome(compareHouses) {
            var data = estprice.getEstPriceForBuildingOnLand(this.dpp, compareHouses);
            var areaPriceAvg = data.areaPriceAvg;
            var areaAvg = data.areaAvg;
            var estPrice = data.estPrice;
            this.estAreaPrice = areaPriceAvg;
            this.estPrice = estPrice;
            this.rangeText = data.estPriceRange;
            this.area = areaAvg;
            this.percentage = null;
            this.isAbove = null;
            this.usingBuildingArea = null;
            this.updateEstValue({
                estPrice: this.estPrice,
                estPricePerArea: this.estAreaPrice,
                estPriceRange: this.rangeText,
            });
        },
        update(compareHouses) {
            if (this.dpp.isLand && compareHouses[0] && !compareHouses[0].isLand) {
                return this.updateLandDataByHome(compareHouses);
            }
            return this.updateData(compareHouses);
        },
        removeItem(i) {
            this.comparableHomeSource.splice(i, 1);
        },
        toogleOpen() {
            this.isOpen = !this.isOpen;
            if (!this.isOpen) {
                this.$refs.homeValueComp.scrollIntoView();
            }
        },
        updateNearbySoldForLand(data) {
            if (data && data.length) {
                this.dpp.nearbySoldForLand = getPropertyList(data, this.glb);
            }
        },
        loadComparableData(type) {
            var id = this.dpp.propertyId;
            var size = 30;
            if (type === 'sold' && !this.loadNearbySold) {
                this.loadNearbySold = true;
                this.fetchNearbySold({
                    id: this.dpp.id,
                    propertyId: this.dpp.propertyId,
                    lat: this.dpp.geo.lat,
                    lng: this.dpp.geo.lng,
                    size: size,
                    propertyType: this.dpp.propertyType,
                }).then((res) => {
                    if (res && res.data) {
                        this.updateNearbySold(res.data || []);
                    }
                    this.comparableSold = sort.sortProperty('similar_desc', this.getNearbySoldHomes.slice(0), this.dpp);
                });
            } else if ((type === 'viewed' || type === 'viewed_land') && !this.loadRecentView) {
                this.loadRecentView = true;
                var ids = this.viewedListings.filter((e) => {
                    return e !== id;
                });
                ids.length = Math.min(ids.length, size);
                this.fetchRecentView({
                    ids: ids,
                }).then(() => {
                    let recentlyViewedList = sort.sortProperty('similar_desc', this.getRecentlyViewed.slice(0), this.dpp);
                    this.comparableViewed = recentlyViewedList.filter((e) => {
                        return e.propertyType === this.dpp.propertyType;
                    });
                    this.comparableViewedLand = recentlyViewedList.filter((e) => {
                        return e.propertyType === this.glb.propertyTypes.single;
                    });
                });
            } else if (type === 'sold_land' && !this.loadNearbySoldForLand) {
                this.loadNearbySoldForLand = true;
                this.fetchNearbySoldForLand({
                    id: this.dpp.id,
                    propertyId: this.dpp.propertyId,
                    lat: this.dpp.geo.lat,
                    lng: this.dpp.geo.lng,
                    size: size,
                    propertyType: this.glb.propertyTypes.single,
                }).then((res) => {
                    this.updateNearbySoldForLand((res && res.data) || []);
                    this.comparableSoldForLand = sort.sortProperty('similar_desc', this.dpp.nearbySoldForLand.slice(0), this.dpp);
                });
            } else if (type === 'sale_land' && !this.loadNearBySaleForLand) {
                this.loadNearBySaleForLand = true;
                this.fetchNearbySaleForLand({
                    propertyId: id,
                    lat: this.dpp.geo.lat,
                    lng: this.dpp.geo.lng,
                    size: size,
                    propertyType: this.glb.propertyTypes.single,
                }).then((res) => {
                    this.updateNearbySaleForLand((res && res.data) || []);
                    this.comparableSaleForLand = sort.sortProperty('similar_desc', this.dpp.nearbySaleForLand.slice(0), this.dpp);
                });
            }
        },
        favoriteAction() {
            this.$eventBus.$emit('property-save-favorite', this.$options.name);
        },
        loadEstimate() {
            if (this.getNearbyHome && this.getNearbyHome.length) {
                this.comparableSale = sort.sortProperty('similar_desc', this.getNearbyHome.slice(0), this.dpp);
                if (!this.comparableType) {
                    this.comparableType = 'sale';
                }
            }

            if (this.getNearbySoldHomes && this.getNearbySoldHomes.length) {
                this.comparableSold = sort.sortProperty('similar_desc', this.getNearbySoldHomes.slice(0), this.dpp);
                if (!this.comparableType) {
                    this.loadNearbySold = true;
                    this.comparableType = 'sold';
                }
            }

            if (this.getRecentlyViewed && this.getRecentlyViewed.length) {
                let recentlyViewedList = sort.sortProperty('similar_desc', this.getRecentlyViewed.slice(0), this.dpp);
                this.comparableViewed = recentlyViewedList.filter((e) => {
                    return e.propertyType === this.dpp.propertyType;
                });
                this.comparableViewedLand = recentlyViewedList.filter((e) => {
                    return e.propertyType === this.glb.propertyTypes.single;
                });
                if (!this.comparableType) {
                    this.loadRecentView = true;
                    this.comparableType = 'viewed';
                }
            }
            if (!this.comparableType) {
                this.comparableType = 'sold';
            }
        },
        openDisclaimer() {
            this.$eventBus.$emit('dialog-center', { name: 'dppPopEst', opt: {}, trigger: this.$options.name });
        },
        openDisclaimer2() {
            this.$eventBus.$emit('dialog-center', { name: 'dppPopAvm', opt: {}, trigger: this.$options.name });
        },
    },
    mounted() {
        this.loadEstimate();
    },
    watch: {
        comparableSourceType(newValue) {
            if (newValue) {
                this.loadComparableData(newValue);
            }
        },
        comparableHomeSource: {
            handler: function (val) {
                this.update(this.comparableHomeSource.slice(0, this.comparableCount));
            },
            deep: true,
        },
    },
};
